import Header from "../components/Header";
import "./../styles/MapPage.scss";

const MapPage = () => {
    return (
        <>
        <div id="map-container" className="app-container">
            <Header  close={true}/>
        </div>
        </>
    )
}

export default MapPage;